import withConfigTransport from '../../services/config-transport/withConfigTransport'

import VaToast from './VaToast.vue'

export default withConfigTransport(VaToast)
